<div class="flex flex-row justify-center items-center content-center" class="contact-container">
  <div class="basis-6/12 xs:basis-11/12 contact-wrapper">
    <span class="close" (click)="close()"><mat-icon>close</mat-icon></span>
    <div class="flex flex-col justify-center items-center content-center">
      <img class="logo" src="../../../../assets/images/logo-img.svg" />
      <h1 mat-dialog-title translate>Contact</h1>
    </div>
    <div>
      Voor vragen over deze actie kun je contact opnemen met onze klantenservice door te mailen naar: <a href="mailto:info@beefund.app">info&#64;beefund.app</a>.<br/>
      Voor vragen over het product verwijzen we je door naar de klantenservice van het desbetreffende merk. Deze informatie is te vinden op de actiepagina.<br/>
      Of kijk of jouw vraag bij veelgestelde vragen hierboven voorkomt.<br/>
      <br/>
      <h3>Tot wanneer is deze actie geldig?</h3>
      De looptijd van de actie is te vinden op de actiepagina.
      Bonnen kunnen tot 2 weken na afloop van de actie worden ingediend.
      <h3>Geldt de actie voor alle varianten van een product?</h3>
      Nee, de actie is alleen geldig voor de varianten die vermeld staan op de actiepagina.
      <h3>Is de actie ook geldig in combinatie met andere acties?</h3>
      Nee, de actie is niet geldig in combinatie met andere producten / acties.
      <h3>Hoe vaak mag ik meedoen aan de actie?</h3>
      Per gebruiker en adres/huishouden/rekeningnummer kun je maximaal 1 keer deelnemen aan de actie. Wij controleren dit aan de hand van je deelnamegegevens.
      <h3>Het uploaden van een foto werkt niet op mijn mobiel?</h3>
      Probeer het nog eens door eerst een foto te maken van je kassabon en deze te selecteren of probeer het eens op een laptop of vaste computer.
    </div>
    <div class="flex flex-row justify-center items-center content-center" class="margin-top-20">
      <button mat-raised-button color="accent" (click)="close()">Sluiten</button>
    </div>
  </div>
</div>
